<template>
  <!-- Off-canvas menu for mobile -->
  <div v-if="!sidebar" class="lg:hidden fixed z-40">
    <div class="fixed inset-0 flex z-40">
      <transition
        enter-active-class="transition-opacity ease-linear duration-300"
        leave-active-class="transition-opacity ease-linear duration-300"
        enter-class="opacity-0"
        enter-to-class="opacity-100"
        leave-class="opacity-100"
        leave-to-class="opacity-0"
      >
        <div v-if="sidebarTransition" class="fixed inset-0">
          <div class="absolute inset-0 bg-slate-900 bg-opacity-75" @click="hideSidebar"></div>
        </div>
      </transition>

      <transition
        enter-active-class="transition ease-in-out duration-300 transform"
        leave-active-class="transition ease-in-out duration-300 transform"
        enter-class="-translate-x-full"
        enter-to-class="translate-x-0"
        leave-class="translate-x-0"
        leave-to-class="-translate-x-full"
      >
        <div v-if="sidebarTransition" class="relative flex-1 flex flex-col max-w-xs w-full bg-slate-900">
          <div class="absolute top-0 right-0 -mr-14 p-1">
            <button
              class="flex items-center justify-center h-12 w-12 rounded-full focus:outline-none focus:bg-gray-600"
              aria-label="Close sidebar"
              @click="hideSidebar"
            >
              <svg class="h-6 w-6 text-white" stroke="currentColor" fill="none" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
          <div class="flex-1 h-0 pt-5 pb-4 overflow-y-auto">
            <router-link to="/" class="flex items-center justify-start px-2 text-white">
              <vue-feather type="chevron-left" class="h-8" />
              <span class="text-sm font-semibold">Dashboard</span>
            </router-link>
            <nav class="mt-5 space-y-1">
              <div v-if="agentView === false">
                <div class="mt-4 px-4">
                  <router-link
                    to="/settings"
                    class="flex items-center text-slate-300 hover:text-white px-2 py-2 rounded-lg text-sm"
                  >
                    Guided Account Setup
                  </router-link>
                </div>
                <div class="py-4 px-4 mt-4">
                  <header class="text-white font-bold mb-1">Account</header>
                  <router-link
                    to="/settings/account/profile"
                    class="flex items-center text-sm text-slate-300 hover:text-white px-2 py-2 rounded-lg"
                  >
                    Profile
                  </router-link>
                  <router-link
                    to="/settings/account/email"
                    class="flex items-center text-sm text-slate-300 hover:text-white px-2 py-2 rounded-lg"
                  >
                    Email
                  </router-link>
                  <router-link
                    to="/settings/account/calendar"
                    class="flex items-center text-sm text-slate-300 hover:text-white px-2 py-2 rounded-lg"
                  >
                    Calendar
                  </router-link>
                  <router-link
                    to="/settings/account/notifications"
                    class="flex items-center text-sm text-slate-300 hover:text-white px-2 py-2 rounded-lg"
                  >
                    Notifications
                  </router-link>
                </div>
                <div v-if="$store.state.general.currentUserAccountDetails.role != 'Contributor'" class="py-4 px-4">
                  <header class="text-white font-bold mb-1">Company</header>
                  <router-link
                    to="/settings/company/profile"
                    class="flex items-center text-slate-300 hover:text-white px-2 py-2 rounded-lg"
                  >
                    Profile
                  </router-link>
                  <router-link
                    to="/settings/company/users"
                    class="flex items-center text-sm text-slate-300 hover:text-white px-2 py-2 rounded-lg"
                  >
                    Users
                  </router-link>
                  <router-link
                    to="/settings/company/billing"
                    class="flex items-center text-sm text-slate-300 hover:text-white px-2 py-2 rounded-lg"
                  >
                    Billing
                  </router-link>
                  <router-link
                    to="/settings/company/scheduling"
                    class="flex items-center text-sm text-slate-300 hover:text-white px-2 py-2 rounded-lg"
                  >
                    Scheduling
                  </router-link>
                  <router-link
                    to="/settings/company/landing_pages"
                    class="flex items-center text-sm text-slate-300 hover:text-white px-2 py-2 rounded-lg"
                  >
                    Landing Pages
                  </router-link>
                  <router-link
                    to="/settings/company/advertising"
                    class="flex items-center text-sm text-slate-300 hover:text-white px-2 py-2 rounded-lg"
                  >
                    Advertising
                  </router-link>
                  <router-link
                    to="/settings/company/onboarding_checklists"
                    class="flex items-center text-sm text-slate-300 hover:text-white px-2 py-2 rounded-lg"
                  >
                    Onboarding Tasks
                  </router-link>
                  <router-link
                    to="/settings/company/offboarding_checklists"
                    class="flex items-center text-sm text-slate-300 hover:text-white px-2 py-2 rounded-lg"
                  >
                    Offboarding Tasks
                  </router-link>
                  <router-link
                    to="/settings/company/training_checklists"
                    class="flex items-center text-slate-300 hover:text-white px-2 py-2 rounded-lg text-sm"
                  >
                    Training Tasks
                  </router-link>
                </div>
                <div v-if="$store.state.general.currentUserAccountDetails.role != 'Contributor'" class="py-4 px-4">
                  <header class="text-white font-bold mb-1">Data Management</header>
                  <router-link
                    to="/settings/data/custom_fields"
                    class="flex items-center text-slate-300 hover:text-white px-2 py-2 rounded-lg"
                  >
                    Custom Fields
                  </router-link>
                </div>
                <div v-if="$store.state.general.currentUserAccountDetails.role != 'Contributor'" class="py-4 px-4">
                  <header class="text-white font-bold mb-1">Workflows</header>
                  <router-link
                    to="/settings/workflows/candidate"
                    class="flex items-center text-slate-300 hover:text-white px-2 py-2 rounded-lg text-sm"
                  >
                    Candidate
                  </router-link>
                  <router-link
                    to="/settings/workflows/team"
                    class="flex items-center text-slate-300 hover:text-white px-2 py-2 rounded-lg text-sm"
                  >
                    Team
                  </router-link>
                </div>
                <div v-if="$store.state.general.currentUserAccountDetails.role != 'Contributor'" class="py-4 px-4">
                  <header class="text-white font-bold mb-1">Templates</header>
                  <router-link
                    to="/settings/templates/email"
                    class="flex items-center text-slate-300 hover:text-white px-2 py-2 rounded-lg text-sm"
                  >
                    Email
                  </router-link>
                  <router-link
                    to="/settings/templates/sms"
                    class="flex items-center text-slate-300 hover:text-white px-2 py-2 rounded-lg text-sm"
                  >
                    SMS
                  </router-link>
                  <router-link
                    to="/settings/templates/esignature"
                    class="flex items-center text-slate-300 hover:text-white px-2 py-2 rounded-lg text-sm"
                  >
                    E-signature
                  </router-link>
                </div>
                <div
                  v-if="
                    $store.state.general.currentUserAccountDetails.isImpersonated &&
                    $store.state.general.currentUserAccountDetails.role == 'Admin'
                  "
                  class="py-4 px-4"
                >
                  <header class="text-white font-bold mb-1">Integrations</header>
                  <router-link
                    to="/settings/integrations/pandadoc"
                    class="flex items-center text-slate-300 hover:text-white px-2 py-2 rounded-lg"
                  >
                    PandaDoc
                  </router-link>
                  <router-link
                    to="/settings/integrations/stripe"
                    class="flex items-center text-base-content/70 hover:text-base-content px-2 py-2 rounded-lg"
                  >
                    Stripe
                  </router-link>
                  <router-link
                    to="/settings/integrations/telco"
                    class="flex items-center text-sm text-base-content/70 hover:text-base-content px-2 py-2 rounded-lg"
                  >
                    Telco
                  </router-link>
                  <router-link
                    to="/settings/integrations/website"
                    class="flex items-center text-sm text-base-content/70 hover:text-base-content px-2 py-2 rounded-lg"
                  >
                    Website
                  </router-link>
                </div>
              </div>
            </nav>
          </div>
        </div>
      </transition>
      <div class="flex-shrink-0 w-14">
        <!-- Force sidebar to shrink to fit close icon -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      sidebar: true,
      sidebarTransition: false,
    };
  },
  computed: {
    agentView() {
      return this.$store.state.general.currentUserAccountDetails.role === 'Agent';
    },
  },
  methods: {
    showSidebar() {
      const self = this;
      self.sidebar = false;
      setTimeout(() => {
        self.sidebarTransition = true;
      }, 25);
    },
    hideSidebar() {
      const self = this;
      setTimeout(() => {
        self.sidebarTransition = false;
      }, 25);
      setTimeout(() => {
        self.sidebar = true;
      }, 325);
    },
    signOut() {
      fetch('/users/sign_out', {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-TOKEN': document.querySelectorAll('[name="csrf-token"]')[0].content,
        },
      })
        .then(response => {})
        .then(data => {
          window.location.href = '/';
        });
    },
  },
};
</script>

<!-- duplicated in NewLayout -->
<style scoped>
@reference "tailwindcss";
.router-link-exact-active.router-link-active {
  @apply bg-slate-800 font-bold text-white;
}
</style>
